import { RequestUtil } from 'pmt-common';
import {
  GET_EXTERNAL_MODULES_START,
  GET_EXTERNAL_MODULES_SUCCESS,
  GET_EXTERNAL_MODULES_FAILURE,
} from './events';
import { API_AVAILABLE_EXTERNAL_MODULES } from './constants';
import { normalizeAvailableModules } from './utils';

export const getExternalModulesStart = () => ({ type: GET_EXTERNAL_MODULES_START });
export const getExternalModulesSuccess = modules => ({
  type: GET_EXTERNAL_MODULES_SUCCESS,
  modules,
});
export const getExternalModulesFailure = error => ({
  type: GET_EXTERNAL_MODULES_FAILURE,
  error,
});

/**
 * Loads the external modules the logged-in user may open in the active program. The same
 * thunk is handed to other modules (as refreshExternalModules) so that an admin who changes
 * a module sees the navigation update without reloading.
 * @return {Function} thunk
 */
export const getExternalModules = () => async (dispatch) => {
  try {
    dispatch(getExternalModulesStart());
    const response = await RequestUtil.getData(API_AVAILABLE_EXTERNAL_MODULES);
    dispatch(getExternalModulesSuccess(normalizeAvailableModules(response)));
  } catch (e) {
    dispatch(getExternalModulesFailure(e));
  }
};
